import React from 'react';
import { Container, Box, Typography } from '@mui/material';

const AnalyticsShowcaseSection = () => {
  return (
    <Box sx={{
      py: { xs: 6, md: 8 },
      textAlign: 'center',
      background: 'linear-gradient(180deg, #f8f9fe 0%, #ffffff 100%)'
    }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h4" 
          sx={{ 
            mb: 2, 
            fontWeight: 700,
            color: '#0A2540'
          }}
        >
          From Raw Reviews to Actionable Insights
        </Typography>
        <Typography 
          variant="h6" 
          sx={{ 
            mb: 8, 
            color: '#546E7A',
            fontWeight: 400,
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          See how our AI transforms customer feedback into revenue-driving insights in three simple steps
        </Typography>
        
        {/* Step 1: Data Extraction */}
        <Box sx={{ mb: 8 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
            <Box sx={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              backgroundColor: '#1976d2',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              mr: 2
            }}>
              1
            </Box>
            <Typography 
              variant="h5" 
              sx={{ 
                fontWeight: 600,
                color: '#0A2540'
              }}
            >
              Smart Data Extraction
            </Typography>
          </Box>
          
          <Box sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 16px 40px -12px rgba(0,0,0,0.15)',
            border: '1px solid rgba(25, 118, 210, 0.1)',
            backgroundColor: 'white',
            p: 2,
            mb: 3
          }}>
            <img
              src="/images/data-extraction-process.png"
              alt="AI extracting insights from customer reviews"
              style={{ 
                width: '100%',
                height: 'auto',
                display: 'block',
                borderRadius: '8px'
              }}
            />
          </Box>
          
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#546E7A',
              fontStyle: 'italic',
              fontSize: '0.9rem'
            }}
          >
            AI automatically identifies key insights from raw customer reviews
          </Typography>
        </Box>

        {/* Step 2: Dashboard Overview */}
        <Box sx={{ mb: 8 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
            <Box sx={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              backgroundColor: '#1976d2',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              mr: 2
            }}>
              2
            </Box>
            <Typography 
              variant="h5" 
              sx={{ 
                fontWeight: 600,
                color: '#0A2540'
              }}
            >
              Complete Analytics Dashboard
            </Typography>
          </Box>
          
          <Box sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 16px 40px -12px rgba(0,0,0,0.15)',
            border: '1px solid rgba(25, 118, 210, 0.1)',
            backgroundColor: 'white',
            p: 2,
            mb: 3
          }}>
            <img
              src="/images/dashboard-overview.png"
              alt="Comprehensive analytics dashboard with metrics and trends"
              style={{ 
                width: '100%',
                height: 'auto',
                display: 'block',
                borderRadius: '8px'
              }}
            />
          </Box>
          
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#546E7A',
              fontStyle: 'italic',
              fontSize: '0.9rem'
            }}
          >
            All insights compiled into revenue metrics, trends, and impact analysis
          </Typography>
        </Box>

        {/* Step 3: Performance Analysis */}
        <Box sx={{ mb: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
            <Box sx={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              backgroundColor: '#1976d2',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              mr: 2
            }}>
              3
            </Box>
            <Typography 
              variant="h5" 
              sx={{ 
                fontWeight: 600,
                color: '#0A2540'
              }}
            >
              Real Results - $45K Revenue Impact
            </Typography>
          </Box>
          
          <Box sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 16px 40px -12px rgba(0,0,0,0.15)',
            border: '1px solid rgba(25, 118, 210, 0.1)',
            backgroundColor: 'white',
            p: 2,
            mb: 3
          }}>
            <img
              src="/images/performance-analysis-chart.png"
              alt="Performance analysis showing revenue impact by product"
              style={{ 
                width: '100%',
                height: 'auto',
                display: 'block',
                borderRadius: '8px'
              }}
            />
          </Box>
          
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#546E7A',
              fontStyle: 'italic',
              fontSize: '0.9rem'
            }}
          >
            Quantified impact showing Hidden Gems, Stars, and Problem Areas
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default AnalyticsShowcaseSection; 